var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        gap: "12px",
        color: "#555",
      },
    },
    [
      _vm.showFetchProgress
        ? _c("div", { staticClass: "mb-2" }, [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-center",
                staticStyle: {
                  gap: "5px",
                  cursor: "pointer",
                  "user-select": "none",
                },
                attrs: {
                  role: "button",
                  "aria-expanded": _vm.fetchProgressExpanded ? "true" : "false",
                },
                on: { click: _vm.toggleFetchProgress },
              },
              [
                _vm.isDataFetchActive
                  ? _c("b-spinner", { attrs: { small: "" } })
                  : _c("span", [
                      _vm._v(_vm._s(_vm.fetchProgressExpanded ? "▼" : "▶")),
                    ]),
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.fetchProgressHeaderTitle)),
                ]),
                _vm.fetchProgressHeaderTime
                  ? _c("span", { staticClass: "text-muted small" }, [
                      _vm._v(_vm._s(_vm.fetchProgressHeaderTime)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.fetchProgressExpanded,
                    expression: "fetchProgressExpanded",
                  },
                ],
                staticClass: "mt-1",
              },
              [
                _vm._l(_vm.revealDataSteps, function (step) {
                  return _c(
                    "div",
                    {
                      key: "reveal-data-" + step.id,
                      staticClass: "status mb-2",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sub-status",
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "padding-left": "18px",
                          },
                        },
                        _vm._l(step.substeps || [], function (substep, ii) {
                          return _c(
                            "div",
                            {
                              key:
                                "ds-" +
                                step.id +
                                "-" +
                                (substep && substep.id != null
                                  ? substep.id
                                  : ii) +
                                "-" +
                                ii,
                              staticClass: "mb-2",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "small font-weight-bold mb-1" },
                                [_vm._v(_vm._s(substep.title))]
                              ),
                              substep.result &&
                              (substep.result.title ||
                                (substep.id !== "2.h2" &&
                                  substep.result.result != null))
                                ? _c(
                                    "div",
                                    { staticStyle: { "padding-left": "8px" } },
                                    [
                                      substep.result.title
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "small text-muted",
                                              staticStyle: {
                                                "white-space": "pre-line",
                                                "line-height": "1.4",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(substep.result.title)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      substep.id !== "2.h2" &&
                                      substep.result.result != null
                                        ? _c(
                                            "pre",
                                            {
                                              staticStyle: {
                                                background: "#eee",
                                                padding: "10px",
                                                "max-height": "160px",
                                                resize: "vertical",
                                                overflow: "auto",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(substep.result.result)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                _vm.loadStatus
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "load-indicator d-flex align-items-center mb-1",
                        staticStyle: { gap: "8px", "padding-left": "18px" },
                      },
                      [
                        _vm.showLoadStatusSpinner
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            class: _vm.loadComplete
                              ? "text-success"
                              : "text-muted",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.loadStatus) +
                                _vm._s(
                                  _vm.loadStepSeconds > 0
                                    ? " (" + _vm.loadStepSeconds + "s)"
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.geneSetEntryLoading &&
                _vm.geneSetEntryProgress &&
                _vm.geneSetEntryProgress.detail
                  ? _c(
                      "div",
                      {
                        staticClass: "small text-muted",
                        staticStyle: {
                          "white-space": "pre-line",
                          "line-height": "1.4",
                          "padding-left": "18px",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.geneSetEntryProgress.detail) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm.showFactorTable
        ? _c(
            "div",
            [
              _vm.gateActive && _vm.gateStepId === "2"
                ? _c(
                    "workflow-step-gate",
                    {
                      on: {
                        continue: function ($event) {
                          return _vm.$emit("approve-gate")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "extra",
                            fn: function () {
                              return [
                                _vm.showResearchIntention
                                  ? [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "small font-weight-bold mb-1 d-block reveal-gate-text",
                                        },
                                        [
                                          _vm._v(
                                            " Research intention (optional) "
                                          ),
                                        ]
                                      ),
                                      _c("textarea", {
                                        staticClass:
                                          "form-control form-control-sm",
                                        staticStyle: {
                                          "min-height": "5em",
                                          resize: "vertical",
                                        },
                                        attrs: {
                                          rows: "3",
                                          placeholder:
                                            "Describe what you want to learn or hypothesize about these genes…",
                                        },
                                        domProps: {
                                          value: _vm.researchIntention,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.$emit(
                                              "update:researchIntention",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "reveal-gate-text",
                                    class: {
                                      "mt-3": _vm.showResearchIntention,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "small font-weight-bold mb-1 d-block reveal-gate-text",
                                      },
                                      [_vm._v(" Data ")]
                                    ),
                                    _vm._l(
                                      _vm.llmFeedScopeOptions,
                                      function (opt) {
                                        return _c(
                                          "div",
                                          {
                                            key: opt.value,
                                            staticClass:
                                              "custom-control custom-radio mb-1",
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                id:
                                                  _vm.llmFeedScopeIdPrefix +
                                                  opt.value,
                                                type: "radio",
                                                name: _vm.llmFeedScopeRadioName,
                                              },
                                              domProps: {
                                                value: opt.value,
                                                checked:
                                                  _vm.llmFeedScope ===
                                                  opt.value,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit(
                                                    "update:llmFeedScope",
                                                    opt.value
                                                  )
                                                },
                                              },
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "custom-control-label reveal-gate-text",
                                                attrs: {
                                                  for:
                                                    _vm.llmFeedScopeIdPrefix +
                                                    opt.value,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [_vm._v(_vm._s(opt.label))]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "small",
                                                    staticStyle: {
                                                      opacity: "0.9",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (" +
                                                        _vm._s(opt.help) +
                                                        ")"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2609872910
                      ),
                    },
                    [
                      _vm.showResearchIntention
                        ? [
                            _vm._v(
                              " Gene-derived evidence is ready. Review phenotypes, gene-set clusters, and genes below. Optionally add a research intention (used as research context for mechanistic hypotheses), then hit Continue. REVEAL will generate mechanistic hypotheses using the data. "
                            ),
                          ]
                        : [
                            _vm._v(
                              " Knowledge graph is ready. Please review the phenotypes, genes and gene sets retrieved with the search terms and research context. Select / unselect phenotypes x gene set cluster families if necessary. Choose which Data to send for hypotheses, then hit Continue. REVEAL will generate mechanistic hypotheses using the data. "
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _c("div", { staticClass: "mb-1" }, [
                _c("div", { staticClass: "flex-grow-1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "font-weight-bold mb-2",
                      staticStyle: { color: "#FF6600", "font-size": "1.2em" },
                    },
                    [
                      _vm._v(
                        " Selected " +
                          _vm._s(_vm.phenotypeCount) +
                          " phenotype" +
                          _vm._s(_vm.phenotypeCount !== 1 ? "s" : "") +
                          " and " +
                          _vm._s(_vm.factorCount) +
                          " gene set cluster" +
                          _vm._s(_vm.factorCount !== 1 ? "s" : "") +
                          " relevant to research context. "
                      ),
                    ]
                  ),
                  _vm.hybridSearchMetaSummaryLines.length
                    ? _c(
                        "ul",
                        { staticClass: "mb-2 pl-3 text-secondary small" },
                        _vm._l(
                          _vm.hybridSearchMetaSummaryLines,
                          function (line, idx) {
                            return _c("li", { key: `hybrid-meta-${idx}` }, [
                              _vm._v(_vm._s(line)),
                            ])
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.showFactorTable
        ? _c("div", [
            _c("div", { staticClass: "criteria-detail" }, [
              _c("div", { staticClass: "mt-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "mb-4",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [_vm._t("data-viz")],
                  2
                ),
                _vm.isPhenotypePath &&
                !_vm.isGeneSetEntryMode &&
                _vm.phenotypeRationaleList.length
                  ? _c("div", { staticClass: "mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "font-weight-bold small text-muted mb-2",
                        },
                        [_vm._v("Selected Rationale")]
                      ),
                      _c(
                        "ul",
                        { staticClass: "list-unstyled small text-muted mb-0" },
                        _vm._l(_vm.phenotypeRationaleList, function (item) {
                          return _c(
                            "li",
                            { key: item.phenotype, staticClass: "mb-2" },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.helpers.getPhenotypeDisplay(
                                      item.phenotype
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(" " + _vm._s(item.rationale) + " "),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "d-flex justify-content-end mb-2" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-outline-secondary d-inline-flex align-items-center",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("download-raw-json")
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "download", "aria-hidden": "true" },
                      }),
                      _vm._v(" Raw data "),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "reveal-factor-table-wrap" },
                  [
                    _vm.isPhenotypePath && !_vm.isGeneSetEntryMode
                      ? _c(
                          "b-table-simple",
                          {
                            staticClass: "mb-0",
                            attrs: { small: "", striped: "", hover: "" },
                          },
                          [
                            _c("thead", { attrs: { variant: "light" } }, [
                              _c("tr", [
                                _c("th", { staticStyle: { width: "72px" } }, [
                                  _vm._v("Included"),
                                ]),
                                _c("th", { staticStyle: { width: "auto" } }, [
                                  _vm._v("Phenotype"),
                                ]),
                                _c("th", { staticStyle: { width: "auto" } }, [
                                  _vm._v("Fetch direction"),
                                ]),
                                _c("th", { staticStyle: { width: "120px" } }, [
                                  _vm._v("Number of gene sets"),
                                ]),
                                _c("th", { staticStyle: { width: "110px" } }, [
                                  _vm._v("Number of genes"),
                                ]),
                                _c("th", { staticStyle: { width: "300px" } }, [
                                  _vm._v("Genes and gene sets in cluster"),
                                ]),
                              ]),
                            ]),
                            _vm._l(
                              _vm.mainFactorTableRowsPaged,
                              function (row) {
                                return _c(
                                  "tbody",
                                  { key: _vm.helpers.getRowKey(row) },
                                  [
                                    _c("tr", [
                                      _c("td", [
                                        _c(
                                          "div",
                                          { staticClass: "text-center" },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "form-check-input d-inline-block",
                                              attrs: {
                                                type: "checkbox",
                                                "aria-label": "Included",
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.helpers.isPairIncluded(
                                                    row
                                                  ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit(
                                                    "pair-included-toggle",
                                                    row,
                                                    $event.target.checked
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helpers.getPhenotypeDisplay(
                                              row.phenotype
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helpers.getFetchDirectionDisplay(
                                              row
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("td", { staticClass: "text-center" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helpers.getGeneSetCountForRow(
                                              row
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "td",
                                        { staticClass: "text-center" },
                                        [
                                          _vm.emphasizeSearchContextGenes
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.helpers.getGeneSearchContextCountDisplay(
                                                      row
                                                    )
                                                  )
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.helpers.getGeneCountForRow(
                                                      row
                                                    )
                                                  )
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-primary",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "toggle-factor-row",
                                                    { item: row }
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.helpers.isFactorRowExpanded(
                                                      row
                                                    )
                                                      ? "Hide"
                                                      : "Show"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm.helpers.isFactorRowExpanded(row)
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "p-0 border-0",
                                              attrs: { colspan: "6" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "bg-light",
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "20px",
                                                    "flex-wrap": "wrap",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "px-3 pt-2 pb-0 w-100",
                                                    },
                                                    [
                                                      _vm.helpers.getFactorConnectivityNetwork(
                                                        row
                                                      ) &&
                                                      _vm.helpers.getFactorConnectivityNetwork(
                                                        row
                                                      ).nodes.length
                                                        ? _c(
                                                            "factor-base-reveal-network",
                                                            {
                                                              attrs: {
                                                                network:
                                                                  _vm.helpers.getFactorConnectivityNetwork(
                                                                    row
                                                                  ),
                                                                height: 220,
                                                                "show-popup-button": true,
                                                                "keep-physics-enabled":
                                                                  "",
                                                                "gene-node-metric-key":
                                                                  "gwas_support",
                                                                "gene-color-by-gwas-support":
                                                                  "",
                                                                "edge-distance-metric-key":
                                                                  "functional_support",
                                                              },
                                                              on: {
                                                                "open-popup":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$emit(
                                                                      "open-factor-connectivity",
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.showGeneSetSubtable &&
                                                  _vm.helpers.getGenesetForFactor(
                                                    row.phenotype,
                                                    row.factor,
                                                    row.fetched_direction
                                                  ).length
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "py-2 px-3",
                                                          staticStyle: {
                                                            display: "flex",
                                                            flex: "1",
                                                            "flex-direction":
                                                              "column",
                                                          },
                                                        },
                                                        [
                                                          !_vm.isGeneSetEntryMode
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "small text-muted mb-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Gene sets in cluster"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c("b-table", {
                                                            attrs: {
                                                              striped: "",
                                                              hover: "",
                                                              small: "",
                                                              responsive: "sm",
                                                              "head-variant":
                                                                "light",
                                                              items:
                                                                _vm.helpers.getGenesetForFactor(
                                                                  row.phenotype,
                                                                  row.factor,
                                                                  row.fetched_direction
                                                                ),
                                                              fields:
                                                                _vm.geneSetSubtableFields,
                                                              "per-page":
                                                                _vm.subtablePerPage,
                                                              "current-page":
                                                                _vm.helpers.getGeneSetSubtableCurrentPage(
                                                                  row
                                                                ),
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "cell(geneset)",
                                                                  fn: function (
                                                                    gsRow
                                                                  ) {
                                                                    return [
                                                                      !_vm.isGeneSetEntryMode
                                                                        ? _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "cfde-explore-geneset-link reveal-soft-wrap-cell",
                                                                              attrs:
                                                                                {
                                                                                  href: _vm.helpers.cfdeExploreAssociationHref(
                                                                                    row.phenotype,
                                                                                    gsRow
                                                                                      .item
                                                                                      .geneset,
                                                                                    gsRow
                                                                                      .item
                                                                                      .program
                                                                                  ),
                                                                                  target:
                                                                                    "_blank",
                                                                                  rel: "noopener noreferrer",
                                                                                  title:
                                                                                    gsRow
                                                                                      .item
                                                                                      .geneset,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.softWrapAtUnderscore(
                                                                                    gsRow
                                                                                      .item
                                                                                      .geneset
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "reveal-soft-wrap-cell",
                                                                              attrs:
                                                                                {
                                                                                  title:
                                                                                    gsRow
                                                                                      .item
                                                                                      .geneset,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.softWrapAtUnderscore(
                                                                                    gsRow
                                                                                      .item
                                                                                      .geneset
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  },
                                                                },
                                                                {
                                                                  key: "cell(actions)",
                                                                  fn: function (
                                                                    gsRow
                                                                  ) {
                                                                    return [
                                                                      gsRow.item
                                                                        .program ===
                                                                      "gtex"
                                                                        ? _c(
                                                                            "button",
                                                                            {
                                                                              staticClass:
                                                                                "btn btn-sm btn-outline-primary",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$emit(
                                                                                      "gene-set-row-toggle",
                                                                                      gsRow
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    gsRow.detailsShowing
                                                                                      ? "Hide"
                                                                                      : "Show"
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                                {
                                                                  key: "row-details",
                                                                  fn: function (
                                                                    gsRow
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              padding:
                                                                                "10px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm
                                                                            .geneSetSources[
                                                                            gsRow
                                                                              .item
                                                                              .geneset
                                                                          ]
                                                                            ? _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "b-card",
                                                                                    [
                                                                                      _c(
                                                                                        "a",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              href: _vm
                                                                                                .geneSetSources[
                                                                                                gsRow
                                                                                                  .item
                                                                                                  .geneset
                                                                                              ]
                                                                                                .geneSetUrl,
                                                                                              target:
                                                                                                "_blank",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm
                                                                                                .geneSetSources[
                                                                                                gsRow
                                                                                                  .item
                                                                                                  .geneset
                                                                                              ]
                                                                                                .geneSet
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "ul",
                                                                                        _vm._l(
                                                                                          _vm
                                                                                            .geneSetSources[
                                                                                            gsRow
                                                                                              .item
                                                                                              .geneset
                                                                                          ]
                                                                                            .relations,
                                                                                          function (
                                                                                            rel,
                                                                                            i
                                                                                          ) {
                                                                                            return _c(
                                                                                              "li",
                                                                                              {
                                                                                                key: i,
                                                                                                staticClass:
                                                                                                  "text-muted small",
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "div",
                                                                                                  [
                                                                                                    _c(
                                                                                                      "strong",
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            rel
                                                                                                              .method
                                                                                                              .predicate
                                                                                                          ) +
                                                                                                            ": "
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "a",
                                                                                                      {
                                                                                                        attrs:
                                                                                                          {
                                                                                                            href: rel
                                                                                                              .file
                                                                                                              .dcc_url,
                                                                                                            target:
                                                                                                              "_blank",
                                                                                                          },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            rel
                                                                                                              .file
                                                                                                              .filename
                                                                                                          )
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                                _c(
                                                                                                  "div",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      " via "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "a",
                                                                                                      {
                                                                                                        attrs:
                                                                                                          {
                                                                                                            href: rel
                                                                                                              .method
                                                                                                              .script,
                                                                                                            target:
                                                                                                              "_blank",
                                                                                                          },
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            rel
                                                                                                              .method
                                                                                                              .type
                                                                                                          )
                                                                                                        ),
                                                                                                      ]
                                                                                                    ),
                                                                                                    _vm._v(
                                                                                                      " (" +
                                                                                                        _vm._s(
                                                                                                          rel
                                                                                                            .method
                                                                                                            .direction
                                                                                                        ) +
                                                                                                        ") "
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          }
                                                                                        ),
                                                                                        0
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _c(
                                                                                "div",
                                                                                [
                                                                                  _vm._v(
                                                                                    " no data available yet. "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }),
                                                          _vm.helpers.getGenesetForFactor(
                                                            row.phenotype,
                                                            row.factor,
                                                            row.fetched_direction
                                                          ).length >
                                                          _vm.subtablePerPage
                                                            ? _c(
                                                                "b-pagination",
                                                                {
                                                                  staticClass:
                                                                    "pagination-sm justify-content-center mt-2",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .subtableCurrentPages[
                                                                        _vm.helpers.getRowKey(
                                                                          row
                                                                        ) +
                                                                          "|gs"
                                                                      ],
                                                                    "total-rows":
                                                                      _vm.helpers.getGenesetForFactor(
                                                                        row.phenotype,
                                                                        row.factor,
                                                                        row.fetched_direction
                                                                      ).length,
                                                                    "per-page":
                                                                      _vm.subtablePerPage,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.$emit(
                                                                          "update:subtable-page",
                                                                          {
                                                                            rowKey:
                                                                              _vm.helpers.getRowKey(
                                                                                row
                                                                              ) +
                                                                              "|gs",
                                                                            page: $event,
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.showGeneSubtable
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "subtable-container py-2 px-3",
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                        },
                                                        [
                                                          _vm
                                                            .loadingGenesForFactor[
                                                            _vm.helpers.getRowKey(
                                                              row
                                                            )
                                                          ]
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "small text-muted mb-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Loading genes…"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.isGeneSetEntryMode
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "small text-muted mb-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Genes share membership with anchor gene(s)"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          !_vm
                                                            .loadingGenesForFactor[
                                                            _vm.helpers.getRowKey(
                                                              row
                                                            )
                                                          ]
                                                            ? _c("b-table", {
                                                                attrs: {
                                                                  striped: "",
                                                                  hover: "",
                                                                  small: "",
                                                                  responsive:
                                                                    "sm",
                                                                  "head-variant":
                                                                    "light",
                                                                  items:
                                                                    _vm.helpers.getGenesForFactor(
                                                                      row.phenotype,
                                                                      row.factor,
                                                                      row.fetched_direction
                                                                    ),
                                                                  fields:
                                                                    _vm.geneSubtableFields,
                                                                  "per-page":
                                                                    _vm.subtablePerPage,
                                                                  "current-page":
                                                                    _vm.helpers.getSubtableCurrentPage(
                                                                      row
                                                                    ),
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "cell(gene)",
                                                                        fn: function (
                                                                          gRow
                                                                        ) {
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                style:
                                                                                  _vm.emphasizeSearchContextGenes &&
                                                                                  (gRow
                                                                                    .item
                                                                                    .inSearch ||
                                                                                    gRow
                                                                                      .item
                                                                                      .userRequested ===
                                                                                      "Yes")
                                                                                    ? {
                                                                                        fontWeight: 700,
                                                                                      }
                                                                                    : {
                                                                                        fontWeight: 400,
                                                                                      },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      gRow
                                                                                        .item
                                                                                        .gene
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                      {
                                                                        key: "cell(inSearch)",
                                                                        fn: function (
                                                                          gRow
                                                                        ) {
                                                                          return [
                                                                            gRow
                                                                              .item
                                                                              .inSearch
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-success",
                                                                                    attrs:
                                                                                      {
                                                                                        "aria-label":
                                                                                          "In search",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "✓"
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-muted",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "—"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              })
                                                            : _vm._e(),
                                                          !_vm
                                                            .loadingGenesForFactor[
                                                            _vm.helpers.getRowKey(
                                                              row
                                                            )
                                                          ] &&
                                                          _vm.helpers.getGenesForFactor(
                                                            row.phenotype,
                                                            row.factor,
                                                            row.fetched_direction
                                                          ).length >
                                                            _vm.subtablePerPage
                                                            ? _c(
                                                                "b-pagination",
                                                                {
                                                                  staticClass:
                                                                    "pagination-sm justify-content-center mt-2",
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .subtableCurrentPages[
                                                                        _vm.helpers.getRowKey(
                                                                          row
                                                                        )
                                                                      ],
                                                                    "total-rows":
                                                                      _vm.helpers.getGenesForFactor(
                                                                        row.phenotype,
                                                                        row.factor,
                                                                        row.fetched_direction
                                                                      ).length,
                                                                    "per-page":
                                                                      _vm.subtablePerPage,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.$emit(
                                                                          "update:subtable-page",
                                                                          {
                                                                            rowKey:
                                                                              _vm.helpers.getRowKey(
                                                                                row
                                                                              ),
                                                                            page: $event,
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _c("b-table", {
                          attrs: {
                            items: _vm.mainFactorTableRowsPaged,
                            "primary-key": "_rowKey",
                            fields: _vm.mainAssociationTableFields,
                            small: "",
                            striped: "",
                            hover: "",
                            "head-variant": "light",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(included)",
                                fn: function (row) {
                                  return [
                                    _c("div", { staticClass: "text-center" }, [
                                      _c("input", {
                                        staticClass:
                                          "form-check-input d-inline-block",
                                        attrs: {
                                          type: "checkbox",
                                          "aria-label": "Included in selection",
                                        },
                                        domProps: {
                                          checked: _vm.helpers.isPairIncluded(
                                            row.item
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit(
                                              "pair-included-toggle",
                                              row.item,
                                              $event.target.checked
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(factor)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "reveal-soft-wrap-cell" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.softWrapAtUnderscore(
                                              _vm.helpers.getFactorClusterDisplay(
                                                row.item
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(phenotype)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "reveal-soft-wrap-cell" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.softWrapAtUnderscore(
                                              _vm.helpers.getPhenotypeDisplay(
                                                row.item.phenotype
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(fetchDirection)",
                                fn: function (row) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.helpers.getFetchDirectionDisplay(
                                            row.item
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(geneSetCount)",
                                fn: function (row) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.helpers.getGeneSetCountForRow(
                                            row.item
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(geneCount)",
                                fn: function (row) {
                                  return [
                                    _vm.emphasizeSearchContextGenes
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.helpers.getGeneSearchContextCountDisplay(
                                                row.item
                                              )
                                            )
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm.helpers.getGeneCountForRow(
                                                row.item
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                              {
                                key: "cell(top_gene_sets)",
                                fn: function (row) {
                                  return [
                                    _c("span", { staticClass: "small" }, [
                                      _vm._v(_vm._s(row.item.top_gene_sets)),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(rationale)",
                                fn: function (row) {
                                  return [
                                    row.item.rationale
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "small text-muted",
                                            staticStyle: {
                                              "white-space": "normal",
                                            },
                                          },
                                          [_vm._v(_vm._s(row.item.rationale))]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "small text-muted" },
                                          [_vm._v("—")]
                                        ),
                                  ]
                                },
                              },
                              {
                                key: "cell(view_genes)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-primary",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "toggle-factor-row",
                                              row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.helpers.isFactorRowExpanded(
                                                row.item
                                              )
                                                ? "Hide"
                                                : "Show"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "row-details",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "bg-light",
                                        staticStyle: {
                                          display: "flex",
                                          gap: "20px",
                                          "flex-wrap": "wrap",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "px-3 pt-2 pb-0 w-100",
                                          },
                                          [
                                            _vm.helpers.getFactorConnectivityNetwork(
                                              row.item
                                            ) &&
                                            _vm.helpers.getFactorConnectivityNetwork(
                                              row.item
                                            ).nodes.length
                                              ? _c(
                                                  "factor-base-reveal-network",
                                                  {
                                                    attrs: {
                                                      network:
                                                        _vm.helpers.getFactorConnectivityNetwork(
                                                          row.item
                                                        ),
                                                      height: 220,
                                                      "show-popup-button": true,
                                                      "keep-physics-enabled":
                                                        "",
                                                      "gene-node-metric-key":
                                                        "gwas_support",
                                                      "gene-color-by-gwas-support":
                                                        "",
                                                      "edge-distance-metric-key":
                                                        "functional_support",
                                                    },
                                                    on: {
                                                      "open-popup": function (
                                                        $event
                                                      ) {
                                                        return _vm.$emit(
                                                          "open-factor-connectivity",
                                                          row.item
                                                        )
                                                      },
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm.showGeneSetSubtable &&
                                        _vm.helpers.getGenesetForFactor(
                                          row.item.phenotype,
                                          row.item.factor,
                                          row.item.fetched_direction
                                        ).length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "py-2 px-3",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "flex-direction": "column",
                                                },
                                              },
                                              [
                                                !_vm.isGeneSetEntryMode
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "small text-muted mb-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Gene sets in cluster"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c("b-table", {
                                                  attrs: {
                                                    striped: "",
                                                    hover: "",
                                                    small: "",
                                                    responsive: "sm",
                                                    "head-variant": "light",
                                                    items:
                                                      _vm.helpers.getGenesetForFactor(
                                                        row.item.phenotype,
                                                        row.item.factor,
                                                        row.item
                                                          .fetched_direction
                                                      ),
                                                    fields:
                                                      _vm.geneSetSubtableFields,
                                                    "per-page":
                                                      _vm.subtablePerPage,
                                                    "current-page":
                                                      _vm.helpers.getGeneSetSubtableCurrentPage(
                                                        row.item
                                                      ),
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "cell(geneset)",
                                                        fn: function (gsRow) {
                                                          return [
                                                            !_vm.isGeneSetEntryMode
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "cfde-explore-geneset-link reveal-soft-wrap-cell",
                                                                    attrs: {
                                                                      href: _vm.helpers.cfdeExploreAssociationHref(
                                                                        row.item
                                                                          .phenotype,
                                                                        gsRow
                                                                          .item
                                                                          .geneset,
                                                                        gsRow
                                                                          .item
                                                                          .program
                                                                      ),
                                                                      target:
                                                                        "_blank",
                                                                      rel: "noopener noreferrer",
                                                                      title:
                                                                        gsRow
                                                                          .item
                                                                          .geneset,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.softWrapAtUnderscore(
                                                                          gsRow
                                                                            .item
                                                                            .geneset
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "reveal-soft-wrap-cell",
                                                                    attrs: {
                                                                      title:
                                                                        gsRow
                                                                          .item
                                                                          .geneset,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.softWrapAtUnderscore(
                                                                          gsRow
                                                                            .item
                                                                            .geneset
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(actions)",
                                                        fn: function (gsRow) {
                                                          return [
                                                            gsRow.item
                                                              .program ===
                                                            "gtex"
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-sm btn-outline-primary",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.$emit(
                                                                            "gene-set-row-toggle",
                                                                            gsRow
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          gsRow.detailsShowing
                                                                            ? "Hide"
                                                                            : "Show"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "row-details",
                                                        fn: function (gsRow) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  padding:
                                                                    "10px",
                                                                },
                                                              },
                                                              [
                                                                _vm
                                                                  .geneSetSources[
                                                                  gsRow.item
                                                                    .geneset
                                                                ]
                                                                  ? _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "b-card",
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    href: _vm
                                                                                      .geneSetSources[
                                                                                      gsRow
                                                                                        .item
                                                                                        .geneset
                                                                                    ]
                                                                                      .geneSetUrl,
                                                                                    target:
                                                                                      "_blank",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .geneSetSources[
                                                                                      gsRow
                                                                                        .item
                                                                                        .geneset
                                                                                    ]
                                                                                      .geneSet
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "ul",
                                                                              _vm._l(
                                                                                _vm
                                                                                  .geneSetSources[
                                                                                  gsRow
                                                                                    .item
                                                                                    .geneset
                                                                                ]
                                                                                  .relations,
                                                                                function (
                                                                                  rel,
                                                                                  i
                                                                                ) {
                                                                                  return _c(
                                                                                    "li",
                                                                                    {
                                                                                      key: i,
                                                                                      staticClass:
                                                                                        "text-muted small",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        [
                                                                                          _c(
                                                                                            "strong",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  rel
                                                                                                    .method
                                                                                                    .predicate
                                                                                                ) +
                                                                                                  ": "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "a",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  href: rel
                                                                                                    .file
                                                                                                    .dcc_url,
                                                                                                  target:
                                                                                                    "_blank",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  rel
                                                                                                    .file
                                                                                                    .filename
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        [
                                                                                          _vm._v(
                                                                                            " via "
                                                                                          ),
                                                                                          _c(
                                                                                            "a",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  href: rel
                                                                                                    .method
                                                                                                    .script,
                                                                                                  target:
                                                                                                    "_blank",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  rel
                                                                                                    .method
                                                                                                    .type
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " (" +
                                                                                              _vm._s(
                                                                                                rel
                                                                                                  .method
                                                                                                  .direction
                                                                                              ) +
                                                                                              ") "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c("div", [
                                                                      _vm._v(
                                                                        " no data available yet. "
                                                                      ),
                                                                    ]),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm.helpers.getGenesetForFactor(
                                                  row.item.phenotype,
                                                  row.item.factor,
                                                  row.item.fetched_direction
                                                ).length > _vm.subtablePerPage
                                                  ? _c("b-pagination", {
                                                      staticClass:
                                                        "pagination-sm justify-content-center mt-2",
                                                      attrs: {
                                                        value:
                                                          _vm
                                                            .subtableCurrentPages[
                                                            _vm.helpers.getRowKey(
                                                              row.item
                                                            ) + "|gs"
                                                          ],
                                                        "total-rows":
                                                          _vm.helpers.getGenesetForFactor(
                                                            row.item.phenotype,
                                                            row.item.factor,
                                                            row.item
                                                              .fetched_direction
                                                          ).length,
                                                        "per-page":
                                                          _vm.subtablePerPage,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          _vm.$emit(
                                                            "update:subtable-page",
                                                            {
                                                              rowKey:
                                                                _vm.helpers.getRowKey(
                                                                  row.item
                                                                ) + "|gs",
                                                              page: $event,
                                                            }
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.showGeneSubtable
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "subtable-container py-2",
                                                staticStyle: { flex: "1" },
                                              },
                                              [
                                                !_vm.isGeneSetEntryMode
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "small text-muted mb-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Genes share membership with anchor gene(s)"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c("b-table", {
                                                  attrs: {
                                                    striped: "",
                                                    hover: "",
                                                    small: "",
                                                    responsive: "sm",
                                                    "head-variant": "light",
                                                    items:
                                                      _vm.helpers.getGenesForFactor(
                                                        row.item.phenotype,
                                                        row.item.factor,
                                                        row.item
                                                          .fetched_direction
                                                      ),
                                                    fields:
                                                      _vm.geneSubtableFields,
                                                    "per-page":
                                                      _vm.subtablePerPage,
                                                    "current-page":
                                                      _vm.helpers.getSubtableCurrentPage(
                                                        row.item
                                                      ),
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "cell(gene)",
                                                        fn: function (gRow) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                style:
                                                                  _vm.emphasizeSearchContextGenes &&
                                                                  (gRow.item
                                                                    .inSearch ||
                                                                    gRow.item
                                                                      .userRequested ===
                                                                      "Yes")
                                                                    ? {
                                                                        fontWeight: 700,
                                                                      }
                                                                    : {
                                                                        fontWeight: 400,
                                                                      },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      gRow.item
                                                                        .gene
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(inSearch)",
                                                        fn: function (gRow) {
                                                          return [
                                                            gRow.item.inSearch
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-success",
                                                                    attrs: {
                                                                      "aria-label":
                                                                        "In search",
                                                                    },
                                                                  },
                                                                  [_vm._v("✓")]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-muted",
                                                                  },
                                                                  [_vm._v("—")]
                                                                ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm.helpers.getGenesForFactor(
                                                  row.item.phenotype,
                                                  row.item.factor,
                                                  row.item.fetched_direction
                                                ).length > _vm.subtablePerPage
                                                  ? _c("b-pagination", {
                                                      staticClass:
                                                        "pagination-sm justify-content-center mt-2",
                                                      attrs: {
                                                        value:
                                                          _vm
                                                            .subtableCurrentPages[
                                                            _vm.helpers.getRowKey(
                                                              row.item
                                                            )
                                                          ],
                                                        "total-rows":
                                                          _vm.helpers.getGenesForFactor(
                                                            row.item.phenotype,
                                                            row.item.factor,
                                                            row.item
                                                              .fetched_direction
                                                          ).length,
                                                        "per-page":
                                                          _vm.subtablePerPage,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          _vm.$emit(
                                                            "update:subtable-page",
                                                            {
                                                              rowKey:
                                                                _vm.helpers.getRowKey(
                                                                  row.item
                                                                ),
                                                              page: $event,
                                                            }
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4278850716
                          ),
                        }),
                    _vm.factorTableRowCount > _vm.mainTablePerPage
                      ? _c("b-pagination", {
                          staticClass:
                            "pagination-sm justify-content-center mt-2",
                          attrs: {
                            value: _vm.mainTableCurrentPage,
                            "total-rows": _vm.factorTableRowCount,
                            "per-page": _vm.mainTablePerPage,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.$emit(
                                "update:mainTableCurrentPage",
                                $event
                              )
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }